/**
 * Tour steps for the HomePage dashboard.
 *
 * Each step targets a DOM element via its `data-tour` attribute.
 * The first step uses `target: 'body'` with `placement: 'center'` to act
 * as a full-screen welcome message.
 *
 * @param {Function} t - The i18next translation function from `useTranslation()`.
 * @returns {import('react-joyride').Step[]}
 */
export const getHomePageSteps = (t) => [
    {
        target: 'body',
        placement: 'center',
        title: t('tour.home.step-welcome-title'),
        content: t('tour.home.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-stat-cards"]',
        title: t('tour.home.step-stat-cards-title'),
        content: t('tour.home.step-stat-cards-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-upcoming-appointments"]',
        title: t('tour.home.step-upcoming-title'),
        content: t('tour.home.step-upcoming-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-clients-charts"]',
        title: t('tour.home.step-clients-charts-title'),
        content: t('tour.home.step-clients-charts-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-new-clients-chart"]',
        title: t('tour.home.step-new-clients-title'),
        content: t('tour.home.step-new-clients-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-age-gender-charts"]',
        title: t('tour.home.step-age-gender-title'),
        content: t('tour.home.step-age-gender-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-intolerances-chart"]',
        title: t('tour.home.step-intolerances-title'),
        content: t('tour.home.step-intolerances-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-illnesses-chart"]',
        title: t('tour.home.step-illnesses-title'),
        content: t('tour.home.step-illnesses-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-diets-generated-chart"]',
        title: t('tour.home.step-diets-generated-title'),
        content: t('tour.home.step-diets-generated-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-avg-diet-duration-chart"]',
        title: t('tour.home.step-avg-duration-title'),
        content: t('tour.home.step-avg-duration-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="hp-diets-caloric-chart"]',
        title: t('tour.home.step-caloric-range-title'),
        content: t('tour.home.step-caloric-range-content'),
        disableBeacon: true,
    },
];
